var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.767 16.2281L12.75 11.2071C13.7739 9.98583 14.3348 8.44281 14.334 6.84909C14.3336 5.01459 13.6045 3.25538 12.307 1.95848C11.0095 0.661568 9.25 -0.0668039 7.4155 -0.0664061C5.581 -0.0660083 3.82179 0.663126 2.52488 1.9606C1.22797 3.25807 0.499602 5.01759 0.5 6.85209C0.51402 8.14533 0.889966 9.4088 1.58524 10.4993C2.28052 11.5899 3.26733 12.4639 4.43387 13.0223C5.60041 13.5807 6.90003 13.8013 8.18549 13.659C9.47096 13.5167 10.6909 13.0172 11.707 12.2171L16.742 17.2521C16.8087 17.3221 16.8887 17.3781 16.9774 17.4167C17.066 17.4554 17.1615 17.4759 17.2582 17.477C17.3548 17.4782 17.4508 17.46 17.5404 17.4236C17.6299 17.3871 17.7113 17.3331 17.7797 17.2647C17.848 17.1964 17.902 17.115 17.9385 17.0255C17.975 16.9359 17.9931 16.8399 17.9919 16.7433C17.9908 16.6466 17.9703 16.5511 17.9316 16.4624C17.893 16.3738 17.837 16.2948 17.767 16.2281ZM1.969 6.85209C1.969 5.40826 2.54256 4.02355 3.56351 3.0026C4.58446 1.98166 5.96916 1.40809 7.413 1.40809C8.85684 1.40809 10.2415 1.98166 11.2625 3.0026C12.2834 4.02355 12.857 5.40826 12.857 6.85209C12.857 8.29593 12.2834 9.68063 11.2625 10.7016C10.2415 11.7225 8.85684 12.2961 7.413 12.2961C5.96916 12.2961 4.58446 11.7225 3.56351 10.7016C2.54256 9.68063 1.969 8.29593 1.969 6.85209Z",
    fill: "#464646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.487,
    height: 17.473,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.3ab20f0f3c90a054ebfcf44e18f5a5cf.svg";
export { ForwardRef as ReactComponent };